export var actionTypePrefix = '@@DEVIATIONS';
//# sourceMappingURL=constants.js.map